import type { Recipe } from './fromRecipe'
import { type LabColorInput, toLabColor } from './toLabColor'

export type DentinRecipe = {
  no_layers?: number
  recipe_layer1?: Recipe[]
  recipe_layer2?: Recipe[]
}

export const buildDentinPayload = ({
  ceramicbrand,
  protocol,
  targetcolor,
}: {
  ceramicbrand?: string | null
  protocol?: string
  targetcolor?: LabColorInput | null
}): Record<string, unknown> => {
  const target = toLabColor(targetcolor)

  return {
    ceramicbrand: ceramicbrand || '',
    protocol,
    ...(target ? { targetcolor: target } : {}),
  }
}

export const getDentinRecipe = (
  output?: {
    dentin_recipe?: DentinRecipe | null
  } | null,
): DentinRecipe => {
  return output?.dentin_recipe ?? {}
}
